import React, { useState } from "react";
import { Link } from "react-router-dom";

import { useHooks } from "hooks";
import getMenu from "services/helpers/menuItems";
import useStore from "store";

import Logo from "assets/images/icons/logo.png";
import SidebarArrow from "assets/images/icons/arrow-sidebar.svg";

interface MenuItem {
  key: string;
  label: React.ReactNode;
  icon?: React.ReactNode;
  children?: MenuItem[];
  route?: string;
}

const Navigation: React.FC = () => {
  const { get, t, location } = useHooks();

  const { auth } = useStore();
  const role = get(auth, "data.data.role") || get(auth, "data.role");
  const [opened, setOpen] = useState(null);

  const toggleSubmenu = (key: any) => {
    if (key === opened) {
      setOpen(null);
    } else {
      setOpen(key);
    }
  };

  return (
    <div className="sidebar-wrapper h-full w-[264px]">
      <div className="sidebar-header flex justify-between text-center cursor-pointer text-[#9EA3B5]">
        <Link to="/">
          <img className="w-[170px]" src={Logo} alt="logo" />
        </Link>
        <div className="sidebar-arrow cursor-pointer">
          <img src={SidebarArrow} alt="" />
        </div>
      </div>
      <div className="navigation-bar h-[80vh] overflow-y-scroll no-scrollbar">
        <ul className="">
          {getMenu(role).map((menu: MenuItem, idx) => {
            const hasSubmenu = get(menu, "children", []).length > 0;
            const bordered = get(menu, "border", false);
            return (
              <div key={menu.key + idx}>
                {hasSubmenu ? (
                  <li
                    key={menu.key}
                    className={menu.key === opened ? "active-menu" : ""}
                  >
                    <div
                      className={`${
                        bordered ? "sidebar-item--bordered" : "sidebar-item"
                      }`}
                      onClick={() => toggleSubmenu(menu.key)}
                    >
                      <div className="flex items-center">
                        <div>{menu.icon}</div>
                        <div className="sidebar-item__label ml-4">
                          {menu.label}
                        </div>
                      </div>
                    </div>
                    <div className="submenu-wrapper">
                      {/* {menu.key === opened && ( */}
                      <ul
                        className={
                          menu.key === opened
                            ? "submenu-opened"
                            : "submenu-closed"
                        }
                      >
                        {/* @ts-ignore */}
                        {menu.children.map((submenu: MenuItem) => (
                          <li
                            className="submenu-item-wrapper"
                            key={submenu.key}
                          >
                            <Link
                              to={submenu.route || ""}
                              className="sidebar-subitem"
                            >
                              <span className="submenu-line" />
                              <p>{submenu.label}</p>
                            </Link>
                          </li>
                        ))}
                      </ul>
                      {/* )} */}
                    </div>
                  </li>
                ) : (
                  <li
                    key={menu.key}
                    className={menu.key === opened ? "active-menu" : ""}
                  >
                    <Link
                      onClick={() => toggleSubmenu(menu.key)}
                      to={menu.route || ""}
                      className={
                        bordered ? "sidebar-item--bordered" : "sidebar-item"
                      }
                    >
                      <div className="flex items-center">
                        {menu.icon}
                        <span className="ml-4 sidebar-item__label">
                          {t(`${menu.label}`)}
                        </span>
                      </div>
                    </Link>
                  </li>
                )}
              </div>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Navigation;
